/**
 * A set tap on the Club card (build 13, orchestrator ruling). On YOUR swim it opens that swim
 * on the Swim tab, where SetDetailSheet lives: in the Club web view the sheet would read the
 * Swim tab's selected swim (null under native tabs, another swim in pill mode, and "Fix a
 * stroke" would write to it), so the Club view writes no Swim tab store. On a clubmate's swim
 * it does nothing: those sets are a picture. Returns whether it navigated.
 */
import { goToTab } from "../tabNav";

export function ownSetTap(isSelf: boolean, swim: { id: string }): boolean {
  if (!isSelf) return false;
  goToTab("swim", { workoutUUID: swim.id });
  return true;
}
